import { axiosUnos } from "../axios/unos_axios";

export type VideoAddParams = {
  datum: Date;
  title: string;
  fileName: string;
};

export type VideoSearchParams = {
  skip?: number;
  limit?: number;
};

export const videoAdd = async ({
  datum,
  title,
  fileName,
}: VideoAddParams): Promise<string> => {
  let result: string = "";
  let response: any;
  try {
    response = await axiosUnos.post("video", { datum, title, fileName });
  } catch (error) {}
  if (response && response.status === 201) {
    result = response.data;
  }

  return result;
};

const videoResponseFormat = (video: any): any => {
  const result = { ...video, datum: new Date(video.datum) };

  return result;
};

export const videoGet = async (id: string): Promise<any> => {
  let result: any = null;
  let response: any;
  try {
    response = await axiosUnos.get(`video/${id}`);
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
    result = videoResponseFormat(result);
  }

  return result;
};

export const videoSearch = async (
  searchParams?: VideoSearchParams
): Promise<any> => {
  let result: any = null;
  let response: any;
  try {
    response = await axiosUnos.post(`video/search`, searchParams ?? {});
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
    result.items = result.items.map((item: any) => videoResponseFormat(item));
  }

  return result;
};

export const videoUpdate = async (
  id: string,
  updatePayload: any
): Promise<string> => {
  let result: string = "";
  let response: any;
  try {
    response = await axiosUnos.put(`video/${id}`, updatePayload);
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
  }

  return result;
};

export const videoDelete = async (id: string): Promise<boolean> => {
  let result: boolean = false;
  let response: any;
  try {
    response = await axiosUnos.delete(`video/${id}`);
    result = true;
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
  }

  return result;
};
